import React, { useEffect } from "react";
import "../../assets/css/in-game-settings.css";

export function SettingsIcon({ size = 28, color = "#2a5298", style = {} }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            style={{ verticalAlign: "middle", ...style }}
        >
            <circle cx="12" cy="12" r="3" />
            <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09a1.65 1.65 0 0 0-1-1.51 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09a1.65 1.65 0 0 0 1.51-1 1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33h.09A1.65 1.65 0 0 0 9 3.09V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51h.09a1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82v.09a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
        </svg>
    );
}

export function InGameSettingsModal({
    isOpen = true,
    onClose,
    title = "Settings",
    children,
    closeLabel = "Close",
    maxWidth
}) {
    useEffect(() => {
        if (!isOpen) return;

        function handleKeyDown(event) {
            if (event.key === "Escape") {
                onClose?.();
            }
        }

        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    return (
        <div className="in-game-settings-backdrop" onClick={onClose}>
            <div
                className="in-game-settings-dialog"
                style={maxWidth ? { maxWidth } : undefined}
                onClick={e => e.stopPropagation()}
                role="dialog"
                aria-modal="true"
                aria-labelledby="in-game-settings-title"
            >
                <div className="in-game-settings-header">
                    <div id="in-game-settings-title" className="in-game-settings-title">
                        <SettingsIcon size={20} />
                        <span>{title}</span>
                    </div>
                    <button
                        type="button"
                        className="in-game-settings-dismiss-btn"
                        onClick={onClose}
                        aria-label="Close settings"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <div className="in-game-settings-body">
                    {children}
                </div>

                <div className="in-game-settings-footer">
                    <button
                        type="button"
                        className="in-game-settings-close-btn"
                        onClick={onClose}
                    >
                        {closeLabel}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default InGameSettingsModal;
